import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { useLocation } from 'react-router-dom';
import type { BlockViewProps } from '@plone/types';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { Tabs, TabList, Tab, TabPanel } from 'react-aria-components';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import type { TabsData } from '@redturtle/qubicaamf-theme/components/Blocks/Tabs/schema';

/* Style */
import '@redturtle/qubicaamf-theme/components/Blocks/Tabs/editor.scss';
import '@redturtle/qubicaamf-theme/components/Blocks/Tabs/tabs.less';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/Tabs/styles.module.css';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';
import config from '@plone/registry';

type Props = BlockViewProps & {
  data: TabsData;
};

const View = (props: Props) => {
  const { data, className } = props;
  const { tabs_style } = data;
  const metadata = props.metadata || props.properties;
  const location = useLocation();

  const tabsData = isEmpty(data?.tabs) ? [] : data.tabs;
  const Container = config.getComponent('Container').component || 'div';

  return tabsData.length > 0 ? (
    <section
      className={cx(
        'block-tabs',
        styles.block,
        className,
        'mobile-fullwidth-fix',
      )}
      aria-label={data.title}
    >
      <Container className={cx('block-tabs-container', styles.container)}>
        <div className={styles.tabs_block}>
          {data?.title && (
            <div className={styles.tabs_block_header}>
              <div className="title">
                <h2>{data.title}</h2>
              </div>
            </div>
          )}
          <Container>
            <div>
              <Tabs>
                <div className={styles.tabs_wrapper_container}>
                  <TabList
                    className={cx(styles.tabs_wrapper, {
                      [styles.tablist_button_style]: tabs_style === 'buttons',
                    })}
                  >
                    {tabsData.map((tab) => (
                      <Tab
                        key={tab['@id']}
                        id={tab['@id']}
                        className={cx(styles.tab, {
                          [styles.tabs_simple_style]: tabs_style === 'simple',
                          [styles.tabs_button_style]: tabs_style === 'buttons',
                        })}
                      >
                        {tab.title}
                      </Tab>
                    ))}
                  </TabList>
                </div>

                {tabsData.map((tab) => (
                  <TabPanel key={tab['@id']} id={tab['@id']}>
                    <RenderBlocks
                      {...props}
                      location={location}
                      metadata={metadata}
                      content={tab}
                    />
                  </TabPanel>
                ))}
              </Tabs>
            </div>

            {data.linkHref?.[0] && (
              <div className={styles.ctaContainer}>
                <CTA
                  href={data.linkHref[0]['@id']}
                  openLinkInNewTab={false}
                  ctaButtonStyle={data.ctaButtonStyle}
                  linkIcon={data.linkIcon}
                  cta_color={data.cta_color}
                >
                  {data.linkTitle}
                </CTA>
              </div>
            )}
          </Container>
        </div>
      </Container>
    </section>
  ) : (
    <></>
  );
};

export default withBlockExtensions(View);
